<template>
  <div class="container">
    <div>
      <b-row align-h="end">
        <b-button variant="danger" class="mr-2" @click="reset_trade_journal"
          >Reset Trade Journal</b-button
        >
        <div>
          <b-dropdown id="dropdown-1" text="Import Trade" class="mr-2">
            <b-dropdown-item v-b-modal.file_modal
              >TD AMERITRADE</b-dropdown-item
            >
            <b-dropdown-item v-b-modal.webull_file_modal
              >Webull</b-dropdown-item
            >
          </b-dropdown>
        </div>
        
        <!-- <b-button class="mr-2" v-b-modal.file_modal>Import Trade</b-button> -->
        <b-button variant="outline-primary" align-h="end" v-b-modal.fund_modal
          >Account Balance</b-button
        >
        <b-button class="ml-2" variant="primary" v-b-modal.manual_trade
          >Add Trade</b-button
        >
      </b-row>
      <!-- Filters -->
      <b-row align-h="start">
        <div>
          <b-dropdown
            id="dropdown-form"
            text="Symbol"
            ref="dropdown"
            class="m-2"
          >
            <b-dropdown-form>
              <!-- <b-form-checkbox class="mb-3">Select All</b-form-checkbox> -->
              <b-form-tags v-model="selected_stock" no-outer-focus>
                <template
                  v-slot="{
                    tags,
                    inputAttrs,
                    inputHandlers,
                    tagVariant,
                    removeTag,
                  }"
                >
                  <b-input-group>
                    <b-form-input
                      v-bind="inputAttrs"
                      v-on="inputHandlers"
                      placeholder="Search"
                      class="form-control"
                    ></b-form-input>
                  </b-input-group>
                  <div>
                    <b-form-tag
                      v-for="tag in tags"
                      @remove="removeTag(tag)"
                      :key="tag"
                      :title="tag"
                      :variant="tagVariant"
                      >{{ tag }}</b-form-tag
                    >
                  </div>
                </template>
              </b-form-tags>
              <b-form-checkbox-group
                v-model="selected_stock"
                :options="symbol_list"
                class="mb-3"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
              ></b-form-checkbox-group>
            </b-dropdown-form>
          </b-dropdown>
        </div>

        <!-- Setup FIlter -->
        <div>
          <b-dropdown
            id="dropdown-form"
            text="Setup"
            ref="dropdown-2"
            class="m-2"
          >
            <b-dropdown-form>
              <!-- <b-form-checkbox class="mb-3">Select All</b-form-checkbox> -->
              <b-form-tags v-model="selected_stock" no-outer-focus>
                <template
                  v-slot="{
                    tags,
                    inputAttrs,
                    inputHandlers,
                    tagVariant,
                    removeTag,
                  }"
                >
                  <b-input-group>
                    <b-form-input
                      v-bind="inputAttrs"
                      v-on="inputHandlers"
                      placeholder="Search"
                      class="form-control"
                    ></b-form-input>
                  </b-input-group>
                  <div>
                    <b-form-tag
                      v-for="tag in tags"
                      @remove="removeTag(tag)"
                      :key="tag"
                      :title="tag"
                      :variant="tagVariant"
                      >{{ tag }}</b-form-tag
                    >
                  </div>
                </template>
              </b-form-tags>
              <b-form-checkbox-group
                v-model="selected_stock"
                :options="setup_option"
                class="mb-3"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
              ></b-form-checkbox-group>
            </b-dropdown-form>
          </b-dropdown>
        </div>

        <!-- Status filter -->
        <div>
          <b-dropdown
            id="dropdown-form"
            text="Status"
            ref="dropdown-3"
            class="m-2"
          >
            <b-dropdown-form>
              <!-- <b-form-checkbox class="mb-3">Select All</b-form-checkbox> -->
              <b-form-tags v-model="selected_stock" no-outer-focus>
                <template
                  v-slot="{
                    tags,
                    inputAttrs,
                    inputHandlers,
                    tagVariant,
                    removeTag,
                  }"
                >
                  <b-input-group>
                    <b-form-input
                      v-bind="inputAttrs"
                      v-on="inputHandlers"
                      placeholder="Search"
                      class="form-control"
                    ></b-form-input>
                  </b-input-group>
                  <div>
                    <b-form-tag
                      v-for="tag in tags"
                      @remove="removeTag(tag)"
                      :key="tag"
                      :title="tag"
                      :variant="tagVariant"
                      >{{ tag }}</b-form-tag
                    >
                  </div>
                </template>
              </b-form-tags>
              <b-form-checkbox-group
                v-model="selected_stock"
                :options="status_list"
                class="mb-3"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
              ></b-form-checkbox-group>
            </b-dropdown-form>
          </b-dropdown>
        </div>

        <!-- Mistake Filter -->
        <div>
          <b-dropdown
            id="dropdown-form"
            text="Mistake"
            ref="dropdown-4"
            class="m-2"
          >
            <b-dropdown-form>
              <!-- <b-form-checkbox class="mb-3">Select All</b-form-checkbox> -->
              <b-form-tags v-model="selected_stock" no-outer-focus>
                <template
                  v-slot="{
                    tags,
                    inputAttrs,
                    inputHandlers,
                    tagVariant,
                    removeTag,
                  }"
                >
                  <b-input-group>
                    <b-form-input
                      v-bind="inputAttrs"
                      v-on="inputHandlers"
                      placeholder="Search"
                      class="form-control"
                    ></b-form-input>
                  </b-input-group>
                  <div>
                    <b-form-tag
                      v-for="tag in tags"
                      @remove="removeTag(tag)"
                      :key="tag"
                      :title="tag"
                      :variant="tagVariant"
                      >{{ tag }}</b-form-tag
                    >
                  </div>
                </template>
              </b-form-tags>
              <b-form-checkbox-group
                v-model="selected_stock"
                :options="mistake_option"
                class="mb-3"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
              ></b-form-checkbox-group>
            </b-dropdown-form>
          </b-dropdown>
        </div>
      </b-row>
      <div>
        <b-table
          striped
          hover
          bordered
          head-variant="dark"
          light
          sticky-header
          no-border-collapse
          table-variant="dark"
          style="max-height: 100%; min-height: 300px; margin-top: 10px"
          :items="stock_option_array"
          :fields="stock_fields"
          :filter="selected_stock"
          :filter-function="filterTable"
          :busy="isBusy"
        >
          <template #table-busy>
            <div class="text-center text-info my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(tags)="row">
            <b-button
              class="m-2"
              @click="show_tags_modal(row.item, row.index, $event.target)"
              v-for="tag in row.item.tags.setup"
              :key="tag"
              variant="outline-success"
              size="sm"
            >
              {{ tag }}
            </b-button>

            <b-button
              class="m-2"
              @click="show_tags_modal(row.item, row.index, $event.target)"
              v-for="tag in row.item.tags.mistake"
              :key="tag"
              variant="outline-danger"
              size="sm"
            >
              {{ tag }}
            </b-button>

            <b-button
              @click="show_tags_modal(row.item, row.index, $event.target)"
              v-if="row.item.tags.setup.length == 0"
              variant="outline-primary"
              size="sm"
            >
              Add Tags
            </b-button>
          </template>

          <template #cell(side)="row">
            <b-button
              variant="outline-success"
              v-if="row.item.side == 'Long'"
              >{{ row.item.side }}</b-button
            >
            <b-button
              variant="outline-danger"
              v-if="row.item.side == 'Short'"
              >{{ row.item.side }}</b-button
            >
          </template>
          <template #cell(action)="row">
            <b-button @click="delete_trade(row.index)" variant="outline-danger"
              >Delete</b-button
            >
          </template>
        </b-table>
      </div>
    </div>
    <!-- Fund Modal -->
    <b-modal
      id="fund_modal"
      size="lg"
      ref="fund_modal"
      title="Adjustments"
      hide-footer
    >
      <div v-if="show_adj_table">
        <b-table striped hover :items="fund_data" :fields="addjustment_fields">
          <template v-slot:cell(delete)="row">
            <b-button size="sm" @click="remove_data(row)" class="mr-2">
              Del
            </b-button>
          </template>
        </b-table>
        <div>
          <strong>Total fund: {{ total_fund }}</strong>
        </div>
        <b-row align-h="end">
          <b-button class="mr-2" @click="update_fund">
            Add Adjustments
          </b-button>
        </b-row>
      </div>
      <div v-if="!show_adj_table">
        <b-form-group
          id="fieldset-1"
          label="Select Adjustment Type"
          label-for="adj_type"
        >
          <b-form-select
            id="adj_type"
            v-model="adj_type"
            :options="adj_opt"
          ></b-form-select>
        </b-form-group>
        <b-form-group id="fieldset-2" label="Enter amount" label-for="adj_amt">
          <b-form-input
            id="adj_amt"
            type="number"
            v-model="adj_amt"
            placeholder="Enter amount"
          ></b-form-input>
        </b-form-group>

        <b-row>
          <b-col>
            <b-button variant="success" @click="add_fund_data">Submit</b-button>
          </b-col>
          <b-col
            ><b-button variant="danger" align-h="end" @click="reset_fund_modal"
              >Cancel</b-button
            ></b-col
          >
        </b-row>
      </div>
    </b-modal>

    <!-- Add TD AMERITRADE CSV File Modal -->
    <b-modal
      id="file_modal"
      ref="file_modal"
      title="Import TD AMERITRADE Trade"
      hide-footer
    >
      <div v-if="!hide_file_selector">
        <b-form-file
          accept=".csv"
          v-model="csv_file"
          placeholder="Select CSV file"
        ></b-form-file>
        <b-row align-h="center">
          <b-button
            class="mt-2"
            align-h="center"
            @click="loadTextFromFile('td_ameritrade')"
            >Import</b-button
          >
        </b-row>
        <div>
          <b-alert v-model="error_in_csv" variant="danger" dismissible>
            File is not in correct data
          </b-alert>
        </div>
      </div>
      <div v-if="hide_file_selector">
        <h4>Loading...</h4>
        <b-progress
          :value="progress_values"
          :max="progress_max"
          show-progress
          animated
        ></b-progress>
      </div>
    </b-modal>

    <!-- Add WeBull CSV File Modal -->
    <b-modal
      id="webull_file_modal"
      ref="webull_file_modal"
      title="Import Webull Trade"
      hide-footer
    >
      <div v-if="!hide_file_selector">
        <b-form-file
          accept=".csv"
          v-model="csv_file"
          placeholder="Select CSV file"
        ></b-form-file>
        <b-row align-h="center">
          <b-button
            class="mt-2"
            align-h="center"
            @click="loadTextFromFile('we_bull')"
            >Import</b-button
          >
        </b-row>
        <div>
          <b-alert v-model="error_in_csv" variant="danger" dismissible>
            File is not in correct data
          </b-alert>
        </div>
      </div>
      <div v-if="hide_file_selector">
        <h4>Loading...</h4>
        <b-progress
          :value="progress_values"
          :max="progress_max"
          show-progress
          animated
        ></b-progress>
      </div>
    </b-modal>

    <!-- Tags modal -->
    <b-modal id="tags_modal" ref="tags_modal" title="Tags" hide-footer>
      <div class="m-2">
        <label for="tags-basic">SETUPS</label>
        <b-form-tags input-id="tags-setup" v-model="setup_tags"></b-form-tags>
      </div>
      <div class="m-2">
        <label for="tags-basic">MISTAKES</label>
        <b-form-tags
          input-id="tags-mistake"
          v-model="mistake_tags"
        ></b-form-tags>
      </div>
      <div class="m-2">
        <b-button variant="success" @click="update_tags">Submit</b-button>
      </div>
    </b-modal>

    <!-- Add Manual Trade Modal -->
    <b-modal id="manual_trade" ref="manual_trade" title="Add Trade" hide-footer>
      <strong class="mb-2">All Field required</strong>
      <b-row class="m-2">
        <b-row>
          <b-col cols="6">
            <label class="ml-2" for="trade_symbol">Stock Symbol</label>
            <b-form-input
              id="trade_symbol"
              class="mb-2 ml-2"
              v-model="manual_trade.symbol"
              type="text"
              placeholder="Symbol"
            ></b-form-input>
          </b-col>
          <b-col cols="6">
            <label class="ml-2" for="quantity">Quantity</label>
            <b-form-input
              id="quantity"
              class="mb-2 ml-2"
              v-model="manual_trade.quantity"
              type="number"
              placeholder="Enter Quantity"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <label class="ml-2" for="open_date_picker">Enter date</label>
            <b-form-datepicker
              id="open_date_picker"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              locale="en"
              v-model="manual_date"
              class="mb-2 ml-2"
            ></b-form-datepicker>
          </b-col>
          <b-col cols="6">
            <label class="ml-4" for="exit_date_picker">Exit date</label>
            <b-form-datepicker
              id="exit_date_picker"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              v-model="manual_exit_date"
              class="mb-2 ml-4"
            ></b-form-datepicker>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <label class="ml-2" for="entry">Entry Price</label>
            <b-form-input
              id="entry"
              class="mb-2 ml-2"
              v-model="manual_trade.entry"
              type="number"
              placeholder="Enter entry price"
            ></b-form-input>
          </b-col>
          <b-col cols="6">
            <label class="ml-2" for="exit">Exit Price</label>
            <b-form-input
              id="exit"
              class="mb-2 ml-2"
              v-model="manual_trade.exit"
              type="number"
              placeholder="Enter exit price"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <label class="ml-2" for="direction">Direction</label>
            <b-form-select
              id="direction"
              v-model="manual_trade.direction"
              :options="direction"
              class="mb-2 ml-2"
            ></b-form-select>
          </b-col>
          <b-col cols="6">
            <label class="ml-2" for="direction">Length</label>
            <b-form-select
              id="length_time"
              v-model="manual_trade.len"
              :options="length_time"
              class="mb-2 ml-2"
            ></b-form-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <label class="ml-2" for="expiry_date_picker">Expiry date</label>
            <b-form-datepicker
              id="expiry_date_picker"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              locale="en"
              v-model="manual_expiry"
              class="mb-2 ml-2"
            ></b-form-datepicker>
          </b-col>
          <b-col cols="6">
            <label class="ml-3" for="strike_price">Strike Price</label>
            <b-form-input
              id="strike_price"
              class="mb-2 ml-3"
              v-model="manual_trade.strike_price"
              type="number"
              placeholder="Enter Strike Price"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <label class="ml-2" for="transcation_id">Transaction ID</label>
            <b-form-input
              id="transcation_id"
              class="mb-2 ml-2"
              v-model="manual_transaction_id"
              type="text"
              placeholder="Transaction ID"
            ></b-form-input>
          </b-col>
          <b-col cols="6">
            <label class="ml-3" for="trade_type">Trade Type</label>
            <b-form-select
              id="trade_type"
              v-model="manual_trade.side"
              :options="trade_type"
              class="mb-2 ml-2"
            ></b-form-select>
          </b-col>
        </b-row>
        <b-container fluid>
          <b-row align-h="center">
            <b-col cols="4"
              ><b-button
                @click="add_trade"
                class="mt-2"
                variant="outline-primary"
                >Add Trade</b-button
              ></b-col
            >
          </b-row>
        </b-container>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
// import { BIcon} from 'bootstrap-vue'

import db from "../../database/index";
import Swal from "sweetalert2";

const journal_collection = db.collection("journal_data");
const transaction_collection = db.collection("transaction_data");
const fund_collection = db.collection("fund_data");

export default {
  name: "Dashboard",
  components: {
    //  BIcon
  },
  props: {
    discord_id: {
      type: String,
    },
  },
  data() {
    return {
      mistake_tags: [],
      import_type: "",
      setup_tags: [],
      isBusy: false,
      adj_type: null,
      adj_amt: null,
      adj_opt: [
        { value: "Deposit", text: "Deposit" },
        { value: "Withdraw", text: "Withdraw" },
      ],
      id: this.$route.params.id,
      hide_file_selector: false,
      error_in_csv: false,
      csv_file: null,
      csv_data: [],
      stock_tags: [],
      symbol_list: [],
      setup_option: [],
      mistake_option: [],
      status_list: ["Open", "Closed"],
      selected_stock: [],
      selected_status: [],
      progress_values: 0,
      progress_max: 100,
      manipulated_data: [],
      show_adj_table: true,
      required_field_in_csv: [
        "AMOUNT",
        "COMMISSION",
        "DATE",
        "DESCRIPTION",
        "FUND REDEMPTION FEE",
        "PRICE",
        "QUANTITY",
        "REG FEE",
        "SHORT-TERM RDM FEE",
        "SYMBOL",
        "TRANSACTION ID",
      ],
      required_field_in_webull_csv: [
        "Name",
        "Symbol",
        "Side",
        "Status",
        "Filled",
        "Total Qty",
        "Price",
        "Avg Price",
        "Time-in-Force",
        "Placed Time",
        "Filled Time",
      ],
      stock_fields: [
        {
          key: "is_open",
          label: "Status",
          sortable: true,
          formatter: "check_status",
        },
        {
          key: "date",
          label: "Open Date",
          sortable: true,
          formatter: "date_formattor",
        },
        { key: "symbol", sortable: true },
        { key: "symbol_des", label: "Type" },
        { key: "entry", sortable: true, formatter: "rounding_value" },
        { key: "exit", sortable: true, formatter: "rounding_value" },
        {
          key: "return_per",
          sortable: true,
          label: "Return (%)",
          formatter: "rounding_value",
        },
        { key: "return", sortable: true, formatter: "rounding_value" },
        { key: "side", sortable: true },
        { key: "len", label: "Length", sortable: true },
        { key: "tags", label: "Setup" },
        { key: "action", label: "Action" },
      ],
      stock_option_array: [],
      addjustment_fields: [
        {
          key: "type",
          sortable: false,
          label: "Adjustment Type",
        },
        {
          key: "amount",
          sortable: false,
          label: "Value",
        },
        {
          key: "created_at",
        },
        {
          key: "updated_at",
        },
        {
          key: "delete",
          thStyle: {
            color: "white",
          },
        },
      ],
      direction: [
        { value: null, text: "Please select an option" },
        { value: "Call", text: "Call" },
        { value: "Put", text: "Put" },
      ],
      length_time: [
        { value: null, text: "Please select an option" },
        { value: "Swing", text: "Swing" },
        { value: "Day", text: "Day" },
      ],
      trade_type: [
        { value: null, text: "Please select an option" },
        { value: "Long", text: "Long" },
        { value: "Short", text: "Short" },
      ],
      manual_trade: {
        date: "",
        direction: "",
        entry: "",
        exit: "",
        exit_date: "",
        expiry: "",
        invested_amount: "",
        len: "",
        purchase_type: "",
        quantity: "",
        return: "",
        return_per: "",
        returned_amount: "",
        side: "",
        strike_price: "",
        symbol: "",
        symbol_des: "",
      },
      manual_transaction_id: "",
      manual_date: "",
      manual_exit_date: "",
      manual_expiry: "",
      transaction_ids: [],
      fund_data: [],
      total_fund: null,
      tags_index: null,
    };
  },
  async mounted() {
    this.isBusy = true;
    this.load_data();
  },
  methods: {
    reset_trade_journal() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.stock_option_array = [];
          this.transaction_ids = [];
          this.upload_data();
          Swal.fire("Deleted!", "Your data has been deleted.", "success");
        }
      });
    },
    delete_trade(index) {
      this.stock_option_array.splice(index, 1);
      this.upload_data();
    },
    reset_manual_data() {
      for (const data of Object.entries(this.manual_trade)) {
        this.manual_trade[data[0]] = "";
      }
    },
    add_trade() {
      let is_empty = false;
      this.manual_trade["quantity"] = parseInt(this.manual_trade["quantity"]);
      this.manual_trade["entry"] = parseFloat(this.manual_trade["entry"]);
      this.manual_trade["exit"] = parseFloat(this.manual_trade["exit"]);
      this.manual_trade["is_open"] = false;
      this.manual_trade["square_off_qty_remain"] = 0;
      this.manual_trade["strike_price"] = parseFloat(
        this.manual_trade["strike_price"]
      );
      this.manual_trade["invested_amount"] =
        this.manual_trade["entry"] * this.manual_trade["quantity"];
      this.manual_trade["returned_amount"] =
        this.manual_trade["exit"] * this.manual_trade["quantity"];
      this.manual_trade["return"] =
        this.manual_trade["returned_amount"] -
        this.manual_trade["invested_amount"];
      this.manual_trade["return_per"] = parseFloat(
        (
          (this.manual_trade["returned_amount"] /
            this.manual_trade["invested_amount"]) *
          100
        ).toFixed(2)
      );
      this.manual_trade["purchase_type"] =
        this.manual_trade["side"] == "Short" ? "Sold" : "Bought";
      this.manual_trade[
        "symbol_des"
      ] = `${this.manual_trade["symbol"]} ${this.manual_trade["expiry"]} ${this.manual_trade["strike_price"]} ${this.manual_trade["direction"]}`;
      this.manual_trade["date"] = new Date().getTime(this.manual_date);
      this.manual_trade["exit_date"] = new Date().getTime(
        this.manual_exit_date
      );
      this.manual_trade["expiry"] = new Date().getTime(this.manual_expiry);

      console.log(this.manual_trade);
      for (const value of Object.entries(this.manual_trade)) {
        if (value[1] === "" || value[1] === null) {
          is_empty = true;
        }
      }

      if (!is_empty) {
        console.log("I am not empty");
        this.manual_trade["tags"] = { mistake: [], setup: [] };
        this.stock_option_array.push(this.manual_trade);
        this.upload_data();
      }
    },
    show_tags_modal(item, index, button) {
      this.tags_index = index;
      this.mistake_tags = item.tags.mistake;
      this.setup_tags = item.tags.setup;
      this.$root.$emit("bv::show::modal", "tags_modal", button);
    },
    update_tags() {
      this.stock_option_array[this.tags_index]["tags"]["mistake"] =
        this.mistake_tags.map(function (x) {
          return x.toUpperCase();
        });
      this.stock_option_array[this.tags_index]["tags"]["setup"] =
        this.setup_tags.map(function (x) {
          return x.toUpperCase();
        });
      this.$refs["tags_modal"].hide();
      this.upload_data();
    },
    add_fund_data() {
      let fund_data = {
        type: this.adj_type,
        amount: parseInt(this.adj_amt),
        created_at: new Date().toLocaleDateString(),
        updated_at: new Date().toLocaleDateString(),
      };
      this.fund_data.push(fund_data);
      fund_collection
        .doc(this.discord_id.toString())
        .set(Object.assign({}, this.fund_data))
        .then(() => {
          // this.$refs["fund_modal"].hide();
          this.adj_type = null;
          this.adj_amt = null;
          this.show_adj_table = true;
        });
    },
    reset_fund_modal() {
      this.adj_type = null;
      this.adj_amt = null;
      this.show_adj_table = true;
    },
    filterTable(row) {
      let status = row.is_open ? "Open" : "Closed";

      let is_stock_match = this.selected_stock.includes(row.symbol);
      let is_status_match = this.selected_stock.includes(status);
      let is_setup_match = this.selected_stock.some((val) =>
        row.tags.setup.includes(val)
      );
      let is_mistake_match = this.selected_stock.some((val) =>
        row.tags.mistake.includes(val)
      );

      if (
        is_stock_match ||
        is_status_match ||
        is_setup_match ||
        is_mistake_match
      ) {
        return true;
      } else {
        return false;
      }
    },
    load_data() {
      transaction_collection
        .doc(this.id)
        .get()
        .then((doc) => {
          this.transaction_ids = Object.values(doc.data());
        })
        .catch((err) => console.log(err));

      journal_collection
        .doc(this.id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.stock_option_array = Object.values(doc.data());
          } else {
            this.isBusy = false;
          }
        })
        .then(() => {
          // this.symbol_list
          let symbols = this.stock_option_array.map(function (item) {
            return item["symbol"];
          });

          this.symbol_list = symbols.filter(
            (item, index, arry) => arry.indexOf(item) === index
          );

          this.setup_option = this.stock_option_array.flatMap(function (item) {
            return item["tags"]["setup"].flatMap((tag) => {
              return tag;
            });
          });

          this.mistake_option = this.stock_option_array.flatMap(function (
            item
          ) {
            return item["tags"]["mistake"].flatMap((tag) => {
              return tag;
            });
          });
        })
        .then(() => {
          this.isBusy = false;
          console.log(this.stock_option_array);
        })
        .catch((err) => console.log(err));

      fund_collection
        .doc(this.id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.fund_data = Object.values(doc.data());
          }
        })
        .then(() => {
          this.total_fund = this.fund_data.reduce(function (accumulator, item) {
            if (item.type === "Deposit") {
              return accumulator + item.amount;
            } else {
              return accumulator - item.amount;
            }
          }, 0);
        })
        .catch((err) => console.log(err));
    },
    check_status(value) {
      if (value) {
        return "Open";
      } else {
        return "Closed";
      }
    },
    date_formattor(value) {
      return new Date(value).toLocaleDateString();
    },
    rounding_value(value) {
      return Math.round(value * 100) / 100;
      // if (value) {

      // } else {
      //   return "";
      // }
    },
    loadTextFromFile(import_type) {
      this.import_type = import_type;
      const file = this.csv_file;

      console.log("this.import_type ", this.import_type);

      this.$papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: this.onComplete,
      });
    },
    reset_data() {
      this.csv_data = [];
      this.error_in_csv = false;
      this.hide_file_selector = false;
      // this.$bvModal.hide('file_modal')
      this.$refs["file_modal"].hide();
      this.$refs["webull_file_modal"].hide();
    },
    onComplete(results) {
      this.csv_data = [];
      this.error_in_csv = false;
      this.hide_file_selector = true;
      let validatation_data = results.data[0];

      if (this.import_type === "td_ameritrade") {
        // Validated keys
        this.required_field_in_csv.forEach((key) => {
          if (!(key in validatation_data)) {
            this.error_in_csv = true;
            this.hide_file_selector = false;
          }
        });

        if (this.error_in_csv === false) {
          this.csv_data = results.data.reverse();
          this.progress_values = 25;
        }
        this.process_td_ameritrade_data();
      }else{
        // Webull Datat
        this.required_field_in_webull_csv.forEach((key) =>{
          if (!(key in validatation_data)) {
            this.error_in_csv = true;
            this.hide_file_selector = false;
          }
        });

        if (this.error_in_csv === false) {
          this.csv_data = results.data.reverse();
          this.progress_values = 25;
        }

        this.process_webull_data()
      }
    },

    calculate_avg_stock_price(unit1, price1, unit2 = 0, price2 = 0) {
      let unit_price =
        parseFloat(unit1) * parseFloat(price1) +
        parseFloat(unit2) * parseFloat(price2);
      let total_qty = +parseFloat(unit1) + +parseFloat(unit2);
      let result = unit_price / total_qty;
      return result;
    },
    process_td_ameritrade_data() {
      let stock_obj = {};
      this.csv_data.forEach((stock_val) => {
        stock_obj = {};

        if (stock_val["DESCRIPTION"] !== undefined) {
          let details = stock_val["DESCRIPTION"].split(" ");

          // Output of details [Sold ,10 ,BABA, May ,28 ,2021 ,210.0, Put, @ ,2.47]
          if (
            details.length === 10 &&
            !this.transaction_ids.includes(
              parseInt(stock_val["TRANSACTION ID"])
            )
          ) {
            this.transaction_ids.push(parseInt(stock_val["TRANSACTION ID"]));
            // If exist then find index of object with same symbol and strike exists
            stock_obj.symbol_des = stock_val["SYMBOL"];
            stock_obj.purchase_type = details[0];
            stock_obj.quantity = parseFloat(details[1]);
            stock_obj.symbol = details[2];
            stock_obj.expiry = new Date(
              `${details[3]} ${details[4]} ${details[5]}`
            ).getTime();
            stock_obj.strike_price = details[6];
            stock_obj.direction = details[7];
            stock_obj.date = new Date(stock_val["DATE"]).getTime();
            stock_obj.is_open = true;
            stock_obj.invested_amount = parseFloat(stock_val["AMOUNT"]);
            stock_obj.returned_amount = 0.0;
            stock_obj.len = "";
            stock_obj.exit_date = "";

            if (parseFloat(stock_val["AMOUNT"]) > 0) {
              stock_obj.side = "Short";
            } else {
              stock_obj.side = "Long";
            }

            stock_obj.entry = this.calculate_avg_stock_price(
              parseFloat(details[1]),
              parseFloat(details[9])
            );
            stock_obj.exit = 0.0;
            stock_obj.return_per = "";
            stock_obj.return = "";
            stock_obj.square_off_qty_remain = parseFloat(details[1]);
            stock_obj.tags = { mistake: [], setup: [] };

            let index = this.stock_option_array.findIndex((ele) => {
              return (
                ele.symbol === stock_obj.symbol &&
                ele.strike_price == stock_obj.strike_price &&
                ele.direction === stock_obj.direction &&
                ele.expiry == stock_obj.expiry &&
                ele.is_open === true
              );
            }, stock_obj);

            if (index == -1) {
              // Add to array
              this.stock_option_array.push(stock_obj);

              console.log("Added");
            } else {
              let current_stock = this.stock_option_array[index];
              if (
                current_stock.is_open &&
                ((current_stock.purchase_type === "Bought" &&
                  stock_obj.purchase_type === "Sold") ||
                  (current_stock.purchase_type == "Sold" &&
                    stock_obj.purchase_type === "Bought"))
              ) {
                current_stock.square_off_qty_remain =
                  current_stock.square_off_qty_remain - stock_obj.quantity;

                if (current_stock.square_off_qty_remain === 0) {
                  current_stock.is_open = false;
                  current_stock.exit = this.calculate_avg_stock_price(
                    parseFloat(details[1]),
                    parseFloat(details[9])
                  );
                  current_stock.returned_amount =
                    current_stock.returned_amount + stock_obj.invested_amount;
                  current_stock.return =
                    current_stock.invested_amount +
                    current_stock.returned_amount;

                  let return_on_investment;

                  if (current_stock.side === "Long") {
                    return_on_investment =
                      (Math.abs(current_stock.returned_amount) /
                        Math.abs(current_stock.invested_amount)) *
                      100;
                  } else {
                    return_on_investment =
                      (Math.abs(current_stock.invested_amount) /
                        Math.abs(current_stock.returned_amount)) *
                      100;
                  }

                  current_stock.return_per = return_on_investment - 100;

                  let entry_date = new Date(
                    current_stock.date
                  ).toLocaleString();
                  let exit_date = new Date(stock_obj.date).toLocaleString();

                  current_stock.exit_date = new Date(
                    stock_val["DATE"]
                  ).getTime();
                  if (entry_date === exit_date) {
                    current_stock.len = "Day";
                  } else {
                    current_stock.len = "Swing";
                  }
                } else {
                  current_stock.exit = this.calculate_avg_stock_price(
                    parseFloat(details[1]),
                    parseFloat(details[9]),
                    current_stock.quantity,
                    current_stock.exit
                  );
                  current_stock.returned_amount =
                    current_stock.returned_amount + stock_obj.invested_amount;
                }
              } else if (
                current_stock.is_open &&
                ((current_stock.purchase_type === "Sold" &&
                  stock_obj.purchase_type === "Sold") ||
                  (current_stock.purchase_type == "Bought" &&
                    stock_obj.purchase_type === "Bought"))
              ) {
                // Add to qty
                current_stock.square_off_qty_remain =
                  current_stock.square_off_qty_remain + stock_obj.quantity;
                current_stock.quantity =
                  current_stock.quantity + stock_obj.quantity;

                // Average entry price
                current_stock.entry = this.calculate_avg_stock_price(
                  current_stock.quantity,
                  current_stock.entry,
                  parseFloat(details[1]),
                  parseFloat(details[9])
                );

                // Add Invested Amount
                current_stock.invested_amount =
                  current_stock.invested_amount + stock_obj.invested_amount;
              }

              // Updated Object value
              this.stock_option_array[index] = current_stock;
            }
          }
        }
      });
      this.progress_values = 25 + this.progress_values;
      this.auto_exit_trade();
    },
    process_webull_data(){
      let stock_obj = {};
      console.log('this.csv_data ', this.csv_data.length)
      this.csv_data.forEach((stock_val) => {
        stock_obj = {};

        if (stock_val["Name"] !== undefined && stock_val['Status'] !== 'Cancelled') {
          let details = stock_val["Name"].split(" ");


          if (details.length === 6 && !this.transaction_ids.includes(parseInt(new Date(stock_val["Filled Time"]).getTime()))) {
            this.transaction_ids.push(parseInt(new Date(stock_val["Filled Time"]).getTime()));
            

            stock_obj.symbol_des = stock_val["Name"];
            stock_obj.purchase_type = stock_val["Side"] === 'Buy'? 'Bought' : 'Sold'
            stock_obj.quantity = parseFloat(stock_val['Filled']);
            stock_obj.symbol = details[0];
            stock_obj.expiry = new Date(`${details[1]}`).getTime();
            stock_obj.strike_price = details[5];
            stock_obj.direction = details[4];
            stock_obj.date = new Date(stock_val["Filled Time"]).getTime();
            stock_obj.is_open = true;
            stock_obj.invested_amount = parseFloat(stock_val["Avg Price"]) * parseFloat(stock_val['Filled'])
            stock_obj.returned_amount = 0.0;
            stock_obj.len = "";
            stock_obj.exit_date = "";

            if (stock_val["Side"] === 'Buy') {
              stock_obj.side = "Long";
            } else {
              stock_obj.side = "Short";
            }

            stock_obj.entry = this.calculate_avg_stock_price(
              parseFloat(stock_val['Filled']),
              parseFloat(stock_val["Avg Price"])
            );

            stock_obj.exit = 0.0;
            stock_obj.return_per = "";
            stock_obj.return = "";
            stock_obj.square_off_qty_remain = parseFloat(stock_val['Filled']);
            stock_obj.tags = { mistake: [], setup: [] };

            let index = this.stock_option_array.findIndex((ele) => {
              return (
                ele.symbol === stock_obj.symbol &&
                ele.strike_price == stock_obj.strike_price &&
                ele.direction === stock_obj.direction &&
                ele.expiry == stock_obj.expiry &&
                ele.is_open === true
              );
            }, stock_obj);

            if (index == -1) {
              // Add to array
              this.stock_option_array.push(stock_obj);

              console.log("Added");
            }else {
              let current_stock = this.stock_option_array[index];
              if (
                current_stock.is_open &&
                ((current_stock.purchase_type === "Bought" &&
                  stock_obj.purchase_type === "Sold") ||
                  (current_stock.purchase_type == "Sold" &&
                    stock_obj.purchase_type === "Bought"))
              ) {
                current_stock.square_off_qty_remain =
                  current_stock.square_off_qty_remain - stock_obj.quantity;

                if (current_stock.square_off_qty_remain === 0) {
                  current_stock.is_open = false;
                  current_stock.exit = this.calculate_avg_stock_price(
                    parseFloat(stock_val['Filled']),
                    parseFloat(stock_val["Avg Price"])
                  );
                  current_stock.returned_amount =
                    current_stock.returned_amount + stock_obj.invested_amount;
                  current_stock.return =
                    current_stock.invested_amount +
                    current_stock.returned_amount;

                  let return_on_investment;

                  if (current_stock.side === "Long") {
                    return_on_investment =
                      (Math.abs(current_stock.returned_amount) /
                        Math.abs(current_stock.invested_amount)) *
                      100;
                  } else {
                    return_on_investment =
                      (Math.abs(current_stock.invested_amount) /
                        Math.abs(current_stock.returned_amount)) *
                      100;
                  }

                  current_stock.return_per = return_on_investment - 100;

                  let entry_date = new Date(
                    current_stock.date
                  ).toLocaleString();
                  let exit_date = new Date(stock_obj.date).toLocaleString();

                  current_stock.exit_date = new Date(
                    stock_val["DATE"]
                  ).getTime();
                  if (entry_date === exit_date) {
                    current_stock.len = "Day";
                  } else {
                    current_stock.len = "Swing";
                  }
                } else {
                  current_stock.exit = this.calculate_avg_stock_price(
                    parseFloat(stock_val['Filled']),
                    parseFloat(stock_val["Avg Price"]),
                    current_stock.quantity,
                    current_stock.exit
                  );
                  current_stock.returned_amount =
                    current_stock.returned_amount + stock_obj.invested_amount;
                }
              } else if (
                current_stock.is_open &&
                ((current_stock.purchase_type === "Sold" &&
                  stock_obj.purchase_type === "Sold") ||
                  (current_stock.purchase_type == "Bought" &&
                    stock_obj.purchase_type === "Bought"))
              ) {
                // Add to qty
                current_stock.square_off_qty_remain =
                  current_stock.square_off_qty_remain + stock_obj.quantity;
                current_stock.quantity =
                  current_stock.quantity + stock_obj.quantity;

                // Average entry price
                current_stock.entry = this.calculate_avg_stock_price(
                  current_stock.quantity,
                  current_stock.entry,
                  parseFloat(stock_val['Filled']),
                  parseFloat(stock_val["Avg Price"])
                );

                // Add Invested Amount
                current_stock.invested_amount =
                  current_stock.invested_amount + stock_obj.invested_amount;
              }

              // Updated Object value
              this.stock_option_array[index] = current_stock;
            }


          }
        }

      })

      this.progress_values = 25 + this.progress_values;
      this.auto_exit_trade();
    },
    auto_exit_trade() {
      let current_date = new Date().getTime();
      for (let index = 0; index < this.stock_option_array.length; index++) {
        const trade = this.stock_option_array[index];
        console.log(trade);
        if (current_date > trade.expiry && trade.is_open) {
          trade.is_open = false;
          trade.return =
            trade.invested_amount > 0
              ? -trade.invested_amount
              : trade.invested_amount;
          trade.return_per = -100.0;
          trade.square_off_qty_remain = 0;

          if (trade.expiry === trade.date) {
            trade.len = "Day";
          } else {
            trade.len = "Swing";
          }

          this.stock_option_array[index] = trade;
        }
      }
      this.upload_data();
    },
    upload_data() {
      let trades = Object.assign({}, this.stock_option_array);
      let trasactions = Object.assign({}, this.transaction_ids);
      let upload = true;
      if (upload) {
        console.log("this.discord_id ", this.discord_id);
        journal_collection
          .doc(this.discord_id.toString())
          .set(trades)
          .then(() => {
            transaction_collection.doc(this.discord_id).set(trasactions);
            console.log("Data upload");
            this.progress_values = 50 + this.progress_values;
          })
          .then(() => {
            this.reset_data();
            this.load_data();
            this.reset_manual_data();
          })
          .catch((err) => console.log(err));
      }
    },
    update_fund() {
      this.show_adj_table = false;
    },
    remove_data(index) {
      console.log("Removing", index);
      this.fund_data.splice(index, 1);
      fund_collection
        .doc(this.discord_id.toString())
        .set(Object.assign({}, this.fund_data));
    },
  },
};
</script>

<style scoped>
.container {
  color: #f8f8f8;
}
</style>